<template>
    <div class="flex py-3 align-center">
        <v-list-item-avatar class="my-0">
            <v-img :src="avatar"></v-img>
        </v-list-item-avatar>
        <div>
            <v-list-item-title class="align-self-center">
                <Link @click.stop :href="href">
                    {{ title }}
                </Link>
            </v-list-item-title>
            <v-list-item-subtitle>
                {{ subtitle }}
            </v-list-item-subtitle>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/vue2";

export default {
    components: {
        Link,
    },
    props: {
        avatar: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        subtitle: {
            type: String,
            default: null,
        },
        href: {
            type: String,
            default: null,
        },
    },
};
</script>
